import {
    Create,
    useForm,
} from "@refinedev/antd";
import { Form, Input, Switch, Select } from "antd";

export const UserCreate: React.FC = () => {
    const { formProps, saveButtonProps } = useForm({
        resource: "auth/users",
        action: "create",
        redirect: "list",
    });

    // Available roles for the select dropdown
    const roleOptions = [
        { label: "SuperAdmin", value: "SuperAdmin" },
        { label: "Admin", value: "Admin" },
        { label: "POS", value: "POS" }
    ];

    return (
        <Create saveButtonProps={saveButtonProps}>
            <Form {...formProps} layout="vertical">
                <Form.Item
                    label="Username"
                    name="username"
                    rules={[{ required: true }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="Email"
                    name="email"
                    rules={[{ required: true, type: "email" }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="First Name"
                    name="firstName"
                    rules={[{ required: true }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="Last Name"
                    name="lastName"
                    rules={[{ required: true }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="Password"
                    name="password"
                    rules={[{ required: true, min: 6 }]}
                >
                    <Input.Password />
                </Form.Item>
                <Form.Item
                    label="Role"
                    name="role"
                    rules={[{ required: true }]}
                    initialValue="POS"
                >
                    <Select
                        options={roleOptions}
                        placeholder="Select a role"
                    />
                </Form.Item>
            </Form>
        </Create>
    );
}; 